import { app } from 'hyperapp'

import { Widget } from './components/widget'

import './styles/app.scss'

app(Object.assign({}, Widget, { root: document.getElementById('app') }))
